module.exports = ".touched-component {\n  margin-bottom: -7px;\n}\n"